// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scatter{width:25vw;max-width:500px;margin-top:3rem;border-left:1px solid #ECF1F9;color:#1E2B4E}.scatter__dot{height:25px;width:25px;background-color:#1E2B4E;border-radius:50%;display:inline-block}\n", ""]);
// Exports
module.exports = exports;
